import React from 'react'
import { copyToClipboard } from 'tennders-stracture/libs/utils'
import useTranslation from 'next-translate/useTranslation'
import { useToast } from 'tennders-common/hooks/useToast'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/free-solid-svg-icons'

const CompanyInfoHoverCard = ({ company, type }) => {
  const { t } = useTranslation()
  const { toastSuccess } = useToast()
  const companyInformation = {
    VAT: company?.nif,
    document_type: type + (company?.paymentTerm?.cmrType?.label ? ` ${company?.paymentTerm?.cmrType?.label}` : ''),
    payment_days: company?.paymentTerm?.days,
    processing_date: company?.paymentTerm?.processingDate?.label,
    payment_release_date: company?.paymentTerm?.paymentTermReleaseDate?.label,
    payment_release_condition: company?.paymentTerm?.paymentTermReleaseCondition?.label,
    Discount: company?.paymentTerm?.discount
  }

  const types = {
    STANDARD: ['document_type', 'payment_days', 'processing_date', 'payment_release_date'],
    'QUICK PAY': ['document_type', 'payment_release_condition', 'payment_days', 'discount'],
    CONFIRMING: ['document_type', 'processing_date', 'payment_release_condition', 'payment_days', 'discount']
  }

  const items = typeof types[company?.paymentTerm?.type?.code] !== 'undefined' ? types[company?.paymentTerm?.type?.code] : types.STANDARD

  return (
    <div className="tennders-company-info-hover-card transaction-detail">
      <div>
        <strong>{company?.address}</strong>
        {items
          .filter((key) => typeof companyInformation[key] !== 'undefined')
          .map((key, index) => (
            <span key={index}>
              <br />
              {t(`addBranch:${key}`)}
              :
              {' '}
              {companyInformation[key]}
              {' '}
            </span>
          ))}
        <br />
        {company?.pointOfContact?.name}
        {' '}
        <br />
        <div
          onClick={() => {
            const toCopy = company?.pointOfContact?.email || company?.email
            copyToClipboard(toCopy)
            toastSuccess(t('common:copied'))
          }}
        >
          {company?.pointOfContact?.email || company?.email}
          <FontAwesomeIcon icon={faCopy} className="cursor-pointer" />
        </div>
      </div>
    </div>
  )
}

export default CompanyInfoHoverCard
